export default "__VITE_ASSET__Ck0do0CR__"